import { TableDefinitionStore } from '@/tableDefinitionEditor/tableDefinition.store';
import { TableTypeEnum } from '@/sdk/model/TableDefinitionInputV1';
import { sqWorkbookStore } from '@/core/core.stores';
import { ColumnRule } from '@/tableDefinitionEditor/columnRules/columnRule.constants';
import { SeeqNames } from '@/main/app.constants.seeqnames';
import {
  ADD_TO_TREE_PSEUDO_RULE,
  CREATE_TREE_PSEUDO_RULE,
} from '@/tableDefinitionEditor/columnRules/columnRuleBuilder.constants';
import {
  ITEM_TABLE_DEFINITION_CANCELLATION_GROUP,
  ITEM_TABLE_FETCH_CANCELLATION_GROUP,
} from '@/tableDefinitionEditor/tableDefinition.constants';

const DefaultType = TableTypeEnum.ITEM;
export class ItemTableDefinitionStore extends TableDefinitionStore {
  defaultName = 'SCALING.DEFAULT_ITEM_TABLE_NAME';
  static readonly storeName = 'sqItemTableDefinitionStore';

  initialize() {
    this.setupState(DefaultType);
  }

  get name(): string {
    return this.getName({
      currentName: this.state.get('name'),
      tableDefinitions: sqWorkbookStore.itemTables,
      id: this.id,
    });
  }

  getMaterializedTableCancellationGroup(): string {
    return ITEM_TABLE_FETCH_CANCELLATION_GROUP;
  }

  getTableDefinitionCancellationGroup(): string {
    return ITEM_TABLE_DEFINITION_CANCELLATION_GROUP;
  }

  getRulesNotAllowed(): ColumnRule[] {
    const notAllowedInItemTables: ColumnRule[] = [
      SeeqNames.MaterializedTables.Rules.FormulaCreator,
      SeeqNames.MaterializedTables.Rules.AssetCreator,
      SeeqNames.MaterializedTables.Rules.TreePathCreator,
      SeeqNames.MaterializedTables.Rules.EventProperty,
      SeeqNames.MaterializedTables.Rules.ScalarCreator.BaseScalarCreator,
      SeeqNames.MaterializedTables.Rules.StringScalarCreator,
      SeeqNames.MaterializedTables.Rules.NumericScalarCreator,
      CREATE_TREE_PSEUDO_RULE,
      ADD_TO_TREE_PSEUDO_RULE,
      SeeqNames.MaterializedTables.Rules.Ancestor,
    ];

    if (this.tableType === TableTypeEnum.ITEM) {
      return notAllowedInItemTables.concat([
        SeeqNames.MaterializedTables.Rules.ItemSearch,
        SeeqNames.MaterializedTables.Rules.PathSearch,
      ]);
    } else if (this.tableType === TableTypeEnum.ITEMCSV) {
      return notAllowedInItemTables;
    }
    return [];
  }

  override handlers = {
    ITEM_TABLE_DEFINITION_SET_SUBSCRIBER_ID: this.setSubscriberId,
    ITEM_TABLE_DEFINITION_SET_SHOULD_SEARCH_FOR_ITEMS: this.setShouldSearchForItems,
    ITEM_TABLE_DEFINITION_SET_NAME: this.setName,
    ITEM_TABLE_DEFINITION_SET_SEARCH_TYPE_AI: this.setSearchTypeAI,
    ITEM_TABLE_DEFINITION_SET_DESCRIPTION: this.setDescription,
    ITEM_TABLE_DEFINITION_SET_BATCH_ACTION: this.setBatchAction,
    ITEM_TABLE_DEFINITION_SET_DO_TABLE_RELOAD: this.setDoTableReload,
    ITEM_TABLE_DEFINITION_SET_TABLE_DEFINITION: this.setTableDefinition,
    ITEM_TABLE_DEFINITION_SET_MATERIALIZED_TABLE: this.setMaterializedTable,
    ITEM_TABLE_DEFINITION_SET_EVALUATION_RESULTS: this.setEvaluationResults,
    ITEM_TABLE_DEFINITION_RESET: this.reset,
    ITEM_TABLE_DEFINITION_ADD_PENDING_TABLE_ID: this.addPendingTableId,
    ITEM_TABLE_DEFINITION_REMOVE_PENDING_TABLE_ID: this.removePendingTableId,
    ITEM_TABLE_DEFINITION_SET_SHOW_EVALUATION_DETAIL_MODAL: this.setShowEvaluationDetailsModal,
    ITEM_TABLE_DEFINITION_SET_EVALUATION_DETAILS_COLUMN: this.setEvaluationDetailsColumn,
    ITEM_TABLE_DEFINITION_SET_CREATED_ITEM_FINDER_ID: this.setCreatedItemFinderId,
    ITEM_TABLE_DEFINITION_SET_ALLOW_HIDDEN_COLUMNS_AS_INPUTS: this.setAllowHiddenColumnsAsInputs,
    ITEM_TABLE_DEFINITION_SET_AG_GRID_API: this.setAgGridApi,
    ITEM_TABLE_DEFINITION_SET_ROW_DATA_IS_LOADING: this.setRowDataIsLoading,
    REQUEST_SET_PROGRESS: this.requestSetProgress,
    ITEM_TABLE_DEFINITION_SET_SELECTED_COLUMNS: this.setSelectedColumns,
    ITEM_TABLE_DEFINITION_SET_SHOW_CONFIGURE_COLUMN: this.setShowConfigureColumn,
    ITEM_TABLE_DEFINITION_SET_COLUMN_OPTIONS: this.setColumnOptions,
    ITEM_TABLE_DEFINITION_SET_SCROLL_TO_COLUMN_ID: this.setScrollToColumnId,
  };
}
